import { createCardPR } from '@lc/interface/card/pr/factory';

export const PRMeta = [
	createCardPR(
		58,
		1,
		`GET AN ECO-FRIENDLY PRODUCT TO SPONSOR YOUR PODCAST`,
		`“IT’S ALL NATURAL, AND DOESN’T WORK!”`
	),
	createCardPR(
		59,
		1,
		`CONVERT ALL COMPANY VEHICLES TO ELECTRIC`,
		`“WE REALLY JUST PLUGGED THE TAILPIPE.”`
	),
	createCardPR(
		60,
		1,
		`MAKE ALL OF THE C-LEVELS OF YOUR COMPANY GO BACK TO SCHOOL FOR THEIR PHDs`,
		`‘WARMING MIGHT BE GOOD! PITTSBURGH WOULD MAKE A GREAT COASTAL CITY.”`
	),
	createCardPR(
		61,
		2,
		`MAKE A FASHIONABLETINFOIL HAT`,
		`“IT’S ACTUALLY KINDA LONELY WITHOUT THE VOICES.”`
	),
	createCardPR(
		62,
		1,
		`GET AN ATTRACTIVE ACTOR TO APPEAR AS ONE OF YOUR “BEST SCIENTISTS” IN A COMMERCIAL`,
		`“MY SPECIALTY IS GENETICS. SPECIFICALLY, MY GENETICS.”`
	),
	createCardPR(63, 1, `FROST YOUR TIPS`, `‘HAIR'S GRRRREAT!”`),
	createCardPR(
		64,
		1,
		`USE REALLY BIG CHECKS FOR EVERYDAY PURCHASES`,
		`“THIS CASHIER WAS JUST PAID SEVEN DOLLARS AND FIFTY CENTS!”`
	),
	createCardPR(
		65,
		1,
		`INSTALL SLIDE IN THE OFFICE TO BECOME A “FUN PLACE TO WORK”`,
		`“CLIMBING THE CORPORATE CHUTES AND LADDERS.”`
	),
	createCardPR(
		66,
		2,
		`CAMOUFLAGE OFFSHORE WIND TURBINES`,
		`“TURBINES? WHERE?”`
	),
	createCardPR(
		67,
		2,
		`CUT CO2 EMISSIONS IN HALF BY EMITTING CO INSTEAD`,
		`“CATALYTIC CONVERTER? I HARDLY KNOW HER!”`
	),
	createCardPR(
		68,
		2,
		`ADD SUBLIMINAL MESSAGING TO CHILDREN’S MOVIE`,
		`“HEY, I THINK THE OIL BARON KILLING THE MAGIC FOREST MIGHT BE THE BAD GUY!”`
	),
	createCardPR(
		69,
		1,
		`POSE TROLLEY PROBLEM TO HEAD OF BOARD OF DIRECTORS`,
		`“DO WE HAVE TO PAY SEVERANCE?”`
	),
];
